/***
 *
 * Keep track of users' GDPR settings.
 *
 */
import dayjs from 'dayjs';

import CookieUtil from 'tradera-utils/cookie';
import {
    GDPR_CONSENT_COOKIE,
    COOKIE_CATEGORIES
} from 'tradera-constants/cookies';

class GdprSettings {
    /**
     *
     * @param {int} cookieCategory use the constant COOKIE_CATEGORIES to get different values.
     */
    isCategoryEnabled(cookieCategory) {
        if (cookieCategory === COOKIE_CATEGORIES.Essential) {
            return true;
        }
        let decodedCookie = decodeURI(
            CookieUtil.readCookie(GDPR_CONSENT_COOKIE)
        );
        if (decodedCookie === null || decodedCookie.length === 0) {
            return true;
        }

        let categoryPattern = new RegExp(`,${cookieCategory}:1`);
        return categoryPattern.test(decodedCookie);
    }

    isPerformanceEnabled() {
        return this.isCategoryEnabled(COOKIE_CATEGORIES.Performance);
    }

    isFunctionalEnabled() {
        return this.isCategoryEnabled(COOKIE_CATEGORIES.Functional);
    }

    isMarketingEnabled() {
        return this.isCategoryEnabled(COOKIE_CATEGORIES.Marketing);
    }

    set(performance, functional, marketing) {
        const cookie = [
            `${COOKIE_CATEGORIES.Essential}:1`,
            `${COOKIE_CATEGORIES.Performance}:${performance ? '1' : '0'}`,
            `${COOKIE_CATEGORIES.Functional}:${functional ? '1' : '0'}`,
            `${COOKIE_CATEGORIES.Marketing}:${marketing ? '1' : '0'}`
        ];

        CookieUtil.createCookie(
            GDPR_CONSENT_COOKIE,
            cookie.join(','),
            dayjs()
                .add(1, 'years')
                .toDate(),
            '/'
        );
        return this;
    }
}

export default new GdprSettings();
